import { render, staticRenderFns } from "./Etapa4.vue?vue&type=template&id=1079bcc9&scoped=true"
import script from "./Etapa4.vue?vue&type=script&lang=js"
export * from "./Etapa4.vue?vue&type=script&lang=js"
import style0 from "./Etapa4.vue?vue&type=style&index=0&id=1079bcc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079bcc9",
  null
  
)

export default component.exports